var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg182(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.3076,
    y: 49,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(16 29.3076 49)",
    fill: "#01E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7464,
    y: 49,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#E6E7E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.3923,
    y: 51.0837,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(60 43.3923 51.0837)",
    fill: "#E6E7E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0503,
    y: 52.8661,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(-60 33.0503 52.8661)",
    fill: "#E6E7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2162 24.852C52.2414 25.1054 51.2187 25.2403 50.1646 25.2403C43.4852 25.2403 38.0705 19.8256 38.0705 13.1462C38.0705 11.457 38.4169 9.84864 39.0424 8.38831C33.8404 9.74064 30 14.4689 30 20.0941C30 26.7734 35.4147 32.1881 42.094 32.1881C47.0842 32.1881 51.3684 29.1659 53.2162 24.852Z",
    fill: "#CADCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#E6E7E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg182);
export default __webpack_public_path__ + "static/media/182.274f74c8c53fb386e0856477c348643e.svg";
export { ForwardRef as ReactComponent };